module.exports = __webpack_public_path__ + "img/dots-3x2.e79d88f5.svg";